import React, { Fragment } from 'react'
import { connect } from 'react-redux';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { AiFillFunnelPlot } from 'react-icons/ai';
import TFSegment from '../TFSegment';
import EmailIcon from '@mui/icons-material/Email';
import TextsmsIcon from '@mui/icons-material/Textsms';
import ScheduleIcon from '@mui/icons-material/Schedule';
import CallIcon from '@mui/icons-material/Call';

import '../../../containers/Dashboard/dashboard.css';

const Jeopardy = ( { title, subs, contacts } ) => {
    const plan = [
        // { id: 1, title: 'Rickey Henderson', sub: 'Funding on 130 Stolen Bases Dr', c: { firstname: 'Rickey', lastname: 'Henderson', email: 'r@h.com', phone: '123-123-1234' } },
        // { id: 2, title: 'Ozzie Smith', sub: 'Loan Contingency expires on 1 Backflip Ave', c: { firstname: 'Ozzie', lastname: 'Smith', email: 'wizard@oz.com', phone: '123-123-1234' } },
        // { id: 3, title: 'Tom Brady', sub: 'Lock expires on 8 Rings Ct', c: { firstname: 'Tom', lastname: 'Brady', email: 'ring@shopping.com', phone: '123-123-1234' } }
    ];
    const d1 = [
        // { name: "High", value: 2 },
        // { name: "Medium", value: 1 },
        // { name: "Low", value: 0 }
    ];

    const actions = [
        // { icon: <CallIcon />, label: 'Log a Call', type: 'call-log' },
        // { icon: <EmailIcon />, label: 'Send Email', type: 'email', dropdown: true },
        // { icon: <TextsmsIcon />, label: 'Send Txt', type: 'txt', dropdown: true },
    ];

    const segmentMeta = {
        leads: {
            chartTitle: 'Leads',
            gridTitle: 'Leads'
        },
        appreqs: {
            chartTitle: 'Apps',
            gridTitle: 'Apps Requested'
        },
        setups: {
            chartTitle: 'Files',
            gridTitle: 'In Setup'
        },
        pareviews: {
            chartTitle: 'Reviews',
            gridTitle: 'Pre-Approval Reviews'
        },
        pas: {
            chartTitle: 'PAs',
            gridTitle: 'Pre-Approved'
        },
        actives: {
            chartTitle: 'Loans',
            gridTitle: 'Active Loans'
        },
        holds: {
            chartTitle: 'On Hold',
            gridTitle: 'On Hold'
        },
        biz: {
            chartTitle: 'Partners',
            gridTitle: 'Biz Partners'
        },
        closed: {
            chartTitle: 'Closed',
            gridTitle: 'Closed Loans'
        }
    }
    const segmentData = {
        leads: [
            { id: 'con_LLtLUyEHgjzYJVsu6hrI0', oid: 'con_LLtLUyEHgjzYJVsu6hrI0', title: 'Taylan Olsen', sub: 'Realtor.com Lead: No outreach in first 4 hours', c: contacts['con_LLtLUyEHgjzYJVsu6hrI0'] } 
        ],
        appreqs: [ 
            { id: 'con_a8IC8MIf-cSFy0dPLm-4r', oid: 'con_a8IC8MIf-cSFy0dPLm-4r', title: 'Aaron Judge', sub: 'Loan App Not Started: Email sent 2 days ago', c: contacts['con_a8IC8MIf-cSFy0dPLm-4r'] } 
        ],
        pas: [
            { id: 'con_xmdzVHpFN49izGQJV2r3c', oid: 'con_xmdzVHpFN49izGQJV2r3c', title: 'Ozzie Smith', sub: 'Expired Docs: 6+ months since initial review', c: contacts['con_xmdzVHpFN49izGQJV2r3c'] } 
        ],
        actives: [
            { id: 'con_7nE4cdxEjSODJSId0XxDM', oid: 'con_7nE4cdxEjSODJSId0XxDM', title: 'Kerry Carpenter', sub: 'Rush Closing Alert: CTC 1 day before Closing', c: contacts['con_7nE4cdxEjSODJSId0XxDM'] } 
        ],
        holds: [],
        biz: []
    }

    return (
        <Fragment>
            <Row className='tf-dashboard-section-header mx-2'>
                <Col className='p-2 tf-dashboard-section-header-title'>
                    <AiFillFunnelPlot />
                    <span className='ps-2'>{title}</span>
                </Col>
            </Row>
            <Row className='p-0' style={ { overflowX: 'auto' } }>
                {
                    subs.map( ( s ) => (
                        <Col className='p-0' key={`risk-${s}`}>
                            <TFSegment 
                                chartTitle = {segmentData[s].length.toString()}
                                chartSub = {segmentMeta[s].chartTitle}
                                chartData = {d1}
                                gridTitle = {segmentMeta[s].gridTitle}
                                gridData = {segmentData[s]}
                                gridActions = {actions}
                            />
                        </Col>
                    ) )
                }
                
            </Row>
        </Fragment>
    )
}

const mapProps = ( state ) => ( {
    org: state.user.org,
    orgId: state.user.orgId,
    aid: state.user.aid,
    uid: state.user.email,
    viewing: state.user.viewing,
    meta: state.user.meta,
    contacts: state.contacts.byId,
    tasks: state.tasks.byId,
    gameplan: state.gameplan.byId,
    loans: state.loans.byId,
    leadopps: state.leadopps.byId,
    comms: state.comms.byId,
    loanStatus: state.user.meta.loan.picklist.status,
    globalStatus: state.user.meta.global.picklist.status,
} );
  
const mapDispatch = ( dispatch ) => ( {
} );
  
export default connect( mapProps, mapDispatch )( Jeopardy );